// extracted by mini-css-extract-plugin
export var divider = "_rj-0";
export var systemMessage = "_rj-1";